import Tabs from './tabs';

function tabs(props) {
  return new Tabs(props);
}


// DATA-API
$(document).on('click.cd.tabs.data-api', '[data-toggle="cd-tabs"]', function(event) {
  event.stopPropagation();
  let $this = $(event.currentTarget);
  let $parent = $this.parent();

  if ($parent.hasClass('active')) {
    return;
  }

  $parent.addClass('active').siblings().removeClass('active');

  let $panel = $($this.data('target'));
  $panel.addClass('active').siblings().removeClass('active');
})

export default tabs;


//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/lib/tabs/index.js
// module id = 572
// module chunks = 9